/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Language_Switcher_LabelInputs */

const en_language_switcher_label = /** @type {(inputs: Language_Switcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const zh_hans1_language_switcher_label = /** @type {(inputs: Language_Switcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语言`)
};

const pt_br2_language_switcher_label = /** @type {(inputs: Language_Switcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma`)
};

const es_language_switcher_label = /** @type {(inputs: Language_Switcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma`)
};

const fr_language_switcher_label = /** @type {(inputs: Language_Switcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue`)
};

const de_language_switcher_label = /** @type {(inputs: Language_Switcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache`)
};

const ru_language_switcher_label = /** @type {(inputs: Language_Switcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Язык`)
};

const it_language_switcher_label = /** @type {(inputs: Language_Switcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingua`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Language_Switcher_LabelInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const language_switcher_label = /** @type {((inputs?: Language_Switcher_LabelInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Language_Switcher_LabelInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_language_switcher_label(inputs)
	if (locale === "pt-BR") return pt_br2_language_switcher_label(inputs)
	if (locale === "es") return es_language_switcher_label(inputs)
	if (locale === "fr") return fr_language_switcher_label(inputs)
	if (locale === "de") return de_language_switcher_label(inputs)
	if (locale === "ru") return ru_language_switcher_label(inputs)
	if (locale === "it") return it_language_switcher_label(inputs)
	return en_language_switcher_label(inputs)
});